import { Modal } from "../../modal";
import { LineChart } from "../../sensorChart";
import styles from './SensorChartModal.module.scss'


export const SensorsChartModal = ({ open, handleOnClose, sensor, dataToChart}) => {
    

    return (
        <Modal
            showBackArrow
            open={open}
            onClose={handleOnClose}
            width={'85vw'}
            height={'78vh'}
            title={sensor === 'temperature' ? "Temperatura Interna / Externa" :
                sensor === 'humidity' ? "Umidade" : sensor === 'co2' ? "Dióxido de Carbono" : "Vibração Mecânica"}
        >
            <div className={styles.chartContainer}>
                <LineChart sensor={sensor} dataToChart={dataToChart} />
            </div>
            
        </Modal >
    );
}